module.exports = __webpack_public_path__ + "img/centered-logo-nav-infiniti.54cc5011.png";